/**
 *
 * CourseCard
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// utils
import { convertTimeToString } from 'utils/moment/moment.utils';
import { getDayOfWeekObj } from "utils/helpers/helper.generateData";

function CourseCard({
  data,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('course-card', className);

  const courseClasses = data?.classes?.length > 0 && data?.classes?.map((classInfo) => classInfo?.title)?.join(", ");
  return (
    data && (
      <div className={childClassNames}>
        <div className="course-card__top">
          <div className="column">
            <h4>{data?.subject?.name}</h4>
          </div>
          <div className="column">{courseClasses}</div>
        </div>
        <div className="course-card__bottom">
          <div className="column">
            <span className="course-time">
              {`${getDayOfWeekObj(data?.course_week)}, ${convertTimeToString(data?.course_time_start, "H:mm")} - ${convertTimeToString(data?.course_time_end, "H:mm")}`}
            </span>
          </div>
          <div className="column">
            S. {data?.class_room ? data?.class_room : '--'}
          </div>
        </div>
      </div>
    )
  );
}

CourseCard.defaultProps = {};
CourseCard.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
    PropTypes.string,
  ]),
};

export default memo(CourseCard);
